import React from "react";
import { TContainerStateProps } from "./../../state/TContainerStateProps";
import { CRMCardOutside } from "../../components/CRMCardOutside/CRMCardOutside";
import { CRMSpacingColumn } from "../../components/CRMSpacingColumn/CRMSpacingColumn";
import { CRMPadding } from "../../components/Simple/CRMPadding/CRMPadding";
import { CRMSpacing } from "../../models/CRMSpacing";
import { SpacingRow } from "../../components/BuildingBlocks/SpacingRow";
import { CRMParagraph } from "../../components/Simple/CRMParagraph/CRMParagraph";
import { WeightBold } from "../../components/WeightBold/WeightBold";
import { CRMTitleSection } from "../../components/CRMTitleSection/CRMTitleSection";
import { CRMButtonPrimary } from "../../components/CRMButtonPrimary/CRMButtonPrimary";
import { CRMButtonQuaternary } from "../../components/CRMButtonQuaternary/CRMButtonQuaternary";

const CRMLegalCaseProbateGrantMatchesContainer = (props: TContainerStateProps): JSX.Element => {
    const matches = props.state.forms.case_details_page.data.output.probate_grant_matches;

    const confidenceLabel = (confidence: "strong" | "weak"): string =>
        confidence === "strong" ? "Strong match" : "Weak match";

    const statusLabel = (status: "pending" | "confirmed" | "dismissed"): string =>
        status === "confirmed" ? "Confirmed"
        : status === "pending" ? "Needs review"
        : "Dismissed";

    return (
        <CRMCardOutside borderRounding="right">
            <CRMPadding size="large">
                <CRMSpacingColumn spacing="medium">
                    <CRMTitleSection>
                        Probate grant matches
                    </CRMTitleSection>
                    <CRMParagraph>
                        Grants the automated HMCTS check matched to the deceased on this case. Confirm a real match to raise the available grant on the roadblock and flag it to SailHomes, or dismiss a false positive.
                    </CRMParagraph>
                    <CRMSpacingColumn spacing="medium">
                        {matches.map((match) => (
                            <CRMCardOutside key={match.id} borderRounding="right" shadow={false}>
                                <CRMPadding size="medium">
                                    <SpacingRow spacing={CRMSpacing.MEDIUM} justifyContent="space-between" alignItems="center">
                                        <CRMSpacingColumn spacing="tiny">
                                            <CRMParagraph>
                                                <WeightBold>{match.matched_name ?? "Unknown deceased"}</WeightBold>
                                                {` — ${confidenceLabel(match.match_confidence)} (${statusLabel(match.status)})`}
                                            </CRMParagraph>
                                            <CRMParagraph>
                                                {`Probate #${match.probate_number}`}
                                                {match.matched_on !== null ? ` · found ${match.matched_on}` : ""}
                                            </CRMParagraph>
                                        </CRMSpacingColumn>
                                        {match.status === "pending" &&
                                            <SpacingRow spacing={CRMSpacing.SMALL}>
                                                <CRMButtonPrimary
                                                    label="Confirm"
                                                    onClick={() => props.dispatch({
                                                        type: "LEGAL_CASE_CONFIRM_PROBATE_GRANT_MATCH",
                                                        payload: { probate_grant_watch_id: match.id },
                                                    })}
                                                />
                                                <CRMButtonQuaternary
                                                    label="Dismiss"
                                                    onClick={() => props.dispatch({
                                                        type: "LEGAL_CASE_DISMISS_PROBATE_GRANT_MATCH",
                                                        payload: { probate_grant_watch_id: match.id },
                                                    })}
                                                />
                                            </SpacingRow>
                                        }
                                    </SpacingRow>
                                </CRMPadding>
                            </CRMCardOutside>
                        ))}
                    </CRMSpacingColumn>
                </CRMSpacingColumn>
            </CRMPadding>
        </CRMCardOutside>
    );
};

export default CRMLegalCaseProbateGrantMatchesContainer;
